module.exports = __webpack_public_path__ + "img/accessory.f0a1078a.svg";